<template>
  <base-section
    title="Kaon Rの特徴"
    subtitle="プロフェッショナルな環境で、あなたのビジネスをサポートします"
    background="light"
  >
    <div class="features-grid">
      <base-card
        v-for="feature in features"
        :key="feature.id"
        class="feature-card"
        hoverable
      >
        <div class="feature-card__icon">
          <i :class="feature.icon"></i>
        </div>
        <h3 class="feature-card__title">{{ feature.title }}</h3>
        <p class="feature-card__description">{{ feature.description }}</p>
      </base-card>
    </div>
  </base-section>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';
import BaseCard from '@/components/common/BaseCard.vue';

export default {
  name: 'FeaturesSection',
  components: {
    BaseSection,
    BaseCard
  },
  data() {
    return {
      features: [
        {
          id: 1,
          icon: 'fas fa-yen-sign',
          title: '初期費用0円',
          description: '開業資金を抑えて、すぐにサロンをスタート。必要な設備は全て揃っています。'
        },
        {
          id: 2,
          icon: 'fas fa-clock',
          title: '時間単位の利用',
          description: '1時間1,440円から。必要な時間だけ利用できる効率的な料金システム。'
        },
        {
          id: 3,
          icon: 'fas fa-door-closed',
          title: '完全個室空間',
          description: 'プライバシーが守られた落ち着いた空間で、お客様に最高のサービスを。'
        },
        {
          id: 4,
          icon: 'fas fa-map-marker-alt',
          title: '好立地',
          description: '青山一丁目駅徒歩1分。南青山の閑静なエリアでアクセスも抜群。'
        },
        {
          id: 5,
          icon: 'fas fa-tools',
          title: '充実の設備',
          description: 'エステベッド、タオルウォーマーなど、プロ仕様の設備を完備。'
        },
        {
          id: 6,
          icon: 'fas fa-shield-alt',
          title: '安心のサポート',
          description: '女性専用サロンで安心。スタッフが丁寧にサポートいたします。'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: $spacing-lg;
  
  @include media-breakpoint-down(sm) {
    grid-template-columns: 1fr;
  }
}

.feature-card {
  text-align: center;
  padding: $spacing-2xl;
  height: 100%;
  
  &__icon {
    @include flex-center;
    width: 80px;
    height: 80px;
    margin: 0 auto $spacing-lg;
    background-color: rgba($primary-color, 0.1);
    border-radius: $radius-full;
    color: $primary-color;
    font-size: $font-size-3xl;
    transition: all $transition-base;
    
    .base-card:hover & {
      background-color: $primary-color;
      color: $white;
      transform: scale(1.1);
    }
  }
  
  &__title {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $primary-color;
    margin-bottom: $spacing-md;
  }
  
  &__description {
    font-size: $font-size-md;
    color: $gray-600;
    line-height: 1.7;
    margin: 0;
  }
}</style>